import styled from '@emotion/styled/macro';

const Wrapper = styled.div`

`;

const ShowDetailsList = styled.ul`
  margin: 0 0 2rem;
  list-style: none;
`;

const ShowDetailsListItem = styled.li`

`;

const NoteWrapper = styled.div`
  margin-top: 3rem;
  color: ${(props) => props.theme.color.darkGray};
`;

const DescriptionWrapper = styled.div`

`;

export {
  Wrapper,
  ShowDetailsList,
  ShowDetailsListItem,
  NoteWrapper,
  DescriptionWrapper
};
